export const consentResponseStatus = Object.freeze({
  PENDING: 'pending',
  ACTIVE: 'active',
  DEACTIVE: 'deactive',
});
